import { Lang } from 'Roblox';
import angular from 'angular';

const support = angular
  .module('support', ['supportHtmlTemplateApp','robloxApp', 'ui.bootstrap', 'thumbnails','modal', 'captchaV2'])
  .config([
    'languageResourceProvider',
    function(languageResourceProvider) {
      if (Lang.SupportResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.SupportResources);
      }
    }
  ]);

export default support;